import { Navigate, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const FullScreenLoader = () => (
  <div className="flex h-screen items-center justify-center bg-slate-50" data-testid="app-loading">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-brand-500" />
  </div>
);

export const RequireAuth = ({ children }) => {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") return <FullScreenLoader />;
  if (status !== "authed") return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
};

export const Forbidden = () => (
  <div className="mx-auto mt-20 max-w-md text-center" data-testid="forbidden-view">
    <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50 text-red-600">
      <ShieldAlert className="h-6 w-6" />
    </div>
    <h1 className="font-display text-2xl font-bold text-ink">Accesso non consentito</h1>
    <p className="mt-2 text-sm text-slate-500">Il tuo ruolo non dispone dei permessi per questa sezione. Se ritieni sia un errore, contatta l'amministratore.</p>
    <Button asChild variant="outline" className="mt-6" data-testid="forbidden-back-button">
      <a href="/dashboard">Torna alla Dashboard</a>
    </Button>
  </div>
);

export const RequirePermission = ({ perm, children }) => {
  const { can } = useAuth();
  return can(perm) ? children : <Forbidden />;
};
